var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLuggage = function SvgLuggage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7 5V2.5c0-.3-.2-.5-.5-.5S6 1.8 6 1.5v-1c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5s-.5.2-.5.5V5h3c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h3zm3.5-3c.3 0 .5.2.5.5V5H9V2.5c0-.3.2-.5.5-.5h1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 17c.8 0 1.5.7 1.5 1.5S6.3 20 5.5 20 4 19.3 4 18.5 4.7 17 5.5 17zM14.5 17c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5z"
  })));
};
export default SvgLuggage;